import React from 'react';
import { format } from 'date-fns';
import styled from '@emotion/native';
import { BodyText } from '@/shared/components/StyledText';
import { red, subheadline } from '@/shared/styles/colors';
import { ConsultationStatus } from '@/shared/types/generated';
import { getIsConsultationCancelled } from '@/shared/utils';
interface DateTextProps {
  startTime: Date;
  cancelTime?: Date;
  consultationStatus: ConsultationStatus;
}

const DateText: React.FC<DateTextProps> = ({
  startTime,
  cancelTime,
  consultationStatus,
}) => {
  if (
    getIsConsultationCancelled(consultationStatus) &&
    cancelTime !== undefined
  ) {
    let cancellationMessage = '';
    switch (consultationStatus) {
      case ConsultationStatus.Cancelled:
        cancellationMessage = 'Canceled';
        break;
      case ConsultationStatus.StylistNoShow:
        cancellationMessage = 'Stylist No-Show';
        break;
      case ConsultationStatus.ClientNoShow:
        cancellationMessage = 'Client No-Show';
        break;
    }

    return (
      <StyledDateText isCancelled>
        {cancellationMessage} on {'\n'}
        {format(cancelTime, 'eeee MMMM d, yyyy')} at{' '}
        {format(cancelTime, 'h:mmaaa')}
      </StyledDateText>
    );
  }
  return (
    <StyledDateText>
      {format(startTime, 'eeee MMMM d, yyyy')} at {format(startTime, 'h:mmaaa')}
    </StyledDateText>
  );
};

const StyledDateText = styled(BodyText)<{ isCancelled?: boolean }>(
  ({ isCancelled }) => ({
    color: isCancelled ? red : subheadline,
    fontSize: 14,
    marginBottom: 24,
    textAlign: 'center',
    fontWeight: 'bold',
    lineHeight: 16,
  }),
);

export default DateText;
